export default __webpack_public_path__ + "static/media/motor.49260871.webp";